import { Pipe, PipeTransform } from '@angular/core';
import { UniversalSearchPhoneNumberDto } from '../../../../dto';

@Pipe({
    name: 'bestPhoneType',
    standalone: false
})
export class BestPhoneTypePipe implements PipeTransform {
    transform(phoneNumbers: UniversalSearchPhoneNumberDto[], type: 'mobile' | 'work' | 'work_branch' | 'work_mobile' | 'work_dbn' | 'work_hq'): any {
        if (phoneNumbers?.length) {
            const phoneArray = phoneNumbers.map((data: UniversalSearchPhoneNumberDto) => data.type);
            switch (type) {
                case 'mobile':
                    if (phoneArray.indexOf('mobile') > -1) {
                        return 'personalPhone';
                    }
                    break;
                case 'work':
                    if (phoneArray.indexOf('work') > -1) {
                        return 'direct';
                    }
                    break;
                case 'work_branch':
                    if (phoneArray.indexOf('work_branch') > -1) {
                        return 'branch';
                    }
                    break;
                case 'work_mobile':
                    if (phoneArray.indexOf('work_mobile') > -1) {
                        return 'workPhone';
                    }
                    break;
                case 'work_dbn':
                    if (phoneArray.indexOf('work_dbn') > -1) {
                        return 'dbn';
                    }
                    break;
                case 'work_hq':
                    if (phoneArray.indexOf('work_hq') > -1) {
                        return 'hq';
                    }
            }

        }
    }
}
